"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true iff a transform value is "essentially" a specified basis int.
 */
exports.transformValueIsEssentiallyInt = function (transformValue, basis) { return Math.abs(transformValue - basis) < 1e-6; };
//# sourceMappingURL=transformValueIsEssentiallyInt.js.map